import React from 'react';

import * as Yup from 'yup';
import { Button, CircularProgress, Dialog } from '@material-ui/core';
import { DialogContent, TextField } from '@material-ui/core';

import { DialogTitle, Form } from 'components';
import { classes } from 'components/utils';

import styles from './AddSegmentDialog.module.scss';

const initialValues = {
  name: '',
  description: '',
};

const validate = Yup.object().shape({
  name: Yup.string().required('Required'),
  description: Yup.string(),
});

const AddSegmentDialog = props => {
  return (
    <Dialog open={props.open} onClose={props.onClose}>
      <DialogTitle onClose={props.onClose}>Create Segment</DialogTitle>

      <DialogContent>
        <Form
          validationSchema={validate}
          initialValues={initialValues}
          onSubmit={props.onSubmit}
        >
          {({ fieldProps, isSubmitting }) => (
            <div className={classes(styles.segment, isSubmitting ? styles.submit : '')}>
              <div className={styles.content}>
                <TextField {...fieldProps('name', 'Name')} />
                <TextField {...fieldProps('description', 'Description')} />
              </div>

              <div className={styles.footer}>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  disabled={isSubmitting}
                >
                  confirm
                </Button>
              </div>

              <div className={styles.overlay}>
                <CircularProgress size={32} />
              </div>
            </div>
          )}
        </Form>
      </DialogContent>
    </Dialog>
  );
};

export default AddSegmentDialog;
